import { fg } from '@atlassian/jira-feature-gating';

const createProjectFragment = () => `
    project(projectKey: $projectKey) {
        ${!fg('remove-project-id-iviq') ? 'id' : ''}
        ${fg('remove-project-new-issue-view-iviq') ? '' : 'newIssueViewLockedIn'}
        ${
					!fg('remove-issue-types-iviq')
						? `issueTypes {
                                id
                                name
                                iconUrl
                                subtask
                            }`
						: ''
				}
        
    }
`;

export default createProjectFragment;
